import React from 'react';

import { Drawer } from '@mui/material';
import { Close } from '@mui/icons-material';

import {
  HeaderContainer,
  DrawerTitle,
  ContentContainer,
  DrawerWrapper,
} from 'containers/Tasks/components/ActionsSchedulesTable/ScheduleDrawer/styles';

import VersionList from './VersionList';
import { VersionHistoryState } from './useVersionHistory';
import { CloseDrawerButton, DRAWER_PAPER_PROPS } from './styles';

/**
 * The version history panel.
 */
const VersionHistoryDrawer: React.FC<{ state: VersionHistoryState }> = ({ state }): React.ReactElement => (
  <Drawer anchor="right" open={state.open} onClose={state.onClose} PaperProps={DRAWER_PAPER_PROPS}>
    <DrawerWrapper data-testid="submission-version-history-drawer">
      <HeaderContainer>
        <DrawerTitle id="version-history-title">Version history</DrawerTitle>
        <CloseDrawerButton
          onClick={state.onClose}
          aria-label="Close version history"
          data-testid="submission-version-history-close"
        >
          <Close />
        </CloseDrawerButton>
      </HeaderContainer>
      <ContentContainer>
        <VersionList
          loading={state.loading}
          error={state.error}
          versions={state.versions}
          displayed={state.displayed}
          onSelect={state.onSelect}
          onRetry={state.onRetry}
        />
      </ContentContainer>
    </DrawerWrapper>
  </Drawer>
);

export default VersionHistoryDrawer;
